
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'payments-ui-app',
  currentProjectVersion: 'static-1.28626',
  depVersions: {
  "payments-ui-app": "static-1.28626",
  "bend-plugin-arboretum": "static-1.1978",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.507",
  "crm_data": "static-4.93122",
  "data-fetching-client": "static-1.10078",
  "emoji-mart": "static-3.6",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8682",
  "foundations-components-legacy": "static-1.1707",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6023",
  "hs-test-utils": "static-1.8470",
  "hub-http": "static-1.6642",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11925",
  "I18n": "static-7.1698",
  "jasmine-runner": "static-1.6884",
  "quartz": "static-1.7610",
  "raven": "static-3.5925",
  "react-dlb": "static-1.93",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-stripe-js": "static-1.120",
  "react-utils": "static-2.5636",
  "reselect": "static-3.16",
  "stripe-js": "static-1.119",
  "ui-components-test-utils": "static-1.6062",
  "UIComponents": "static-3.8871",
  "usage-tracker-public": "static-1.7558",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38023",
  "payments-checkout-lib": "static-1.549",
  "cssUtils": "static-1.1055",
  "customer-data-objects": "static-1.8127",
  "FireAlarmUi": "static-1.4819",
  "foundations-assets": "static-1.5319",
  "foundations-theming": "static-1.4915",
  "graphql": "static-1.93",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12232",
  "icons": "static-2.699",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3319",
  "property-translator": "static-1.5812",
  "quartz-config": "static-1.1388",
  "quartz-core": "static-1.6829",
  "quartz-i18n": "static-1.1285",
  "quartz-routing": "static-1.1040",
  "quartz-tracking": "static-1.989",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17168",
  "react-select-plus": "static-1.117",
  "react-virtualized": "static-2.111",
  "redux": "static-4.81",
  "redux-thunk": "static-2.84",
  "redux-toolkit": "static-1.82",
  "ReduxMessenger": "static-2.10804",
  "rpc-client-utils": "static-1.5103",
  "sanitize-text": "static-1.8590",
  "SharedI18nStrings": "static-1.187",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.514",
  "superstore": "static-1.5192",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11578",
  "ui-images": "static-2.1269",
  "usage-tracker-core": "static-1.7597",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3887",
  "quartz-webpack": "static-1.3834",
  "bend-plugin-quartz-routing": "static-1.688",
  "bender-build-tools": "static-1.3518",
  "crm_universal": "static-1.22663",
  "customer-data-email": "static-1.18595",
  "customer-data-ui-utilities": "static-1.10266",
  "dispatcher": "static-1.147",
  "frontend-preferences-client": "static-1.8350",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8196",
  "quick-fetch": "static-1.4204",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4951",
  "floating-ui": "static-1.67",
  "foundations-theming-specialty": "static-1.2631",
  "framer-motion": "static-1.83",
  "hs-story-utils": "static-1.9857",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.96",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.2993",
  "ui-fonts": "static-1.1187",
  "HeadJS": "static-2.816",
  "hs-test-utils-bend-plugin": "static-1.3581",
  "msw": "static-1.102",
  "msw-config": "static-1.24",
  "testing-library": "static-1.163",
  "hs-locale-management": "static-1.374",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.95",
  "jasmine": "static-4.4740",
  "foundations-components-test-utils": "static-1.6165",
  "ui-addon-draggable": "static-3.5180",
  "commerce-billing-lib": "static-1.20462",
  "commerce-shared-components-lib": "static-1.19497",
  "commerce-tools-ui-lib": "static-1.11254",
  "crm-message-bus": "static-1.44022",
  "customer-data-objects-ui-components": "static-1.13463",
  "customer-data-properties": "static-1.52939",
  "growth-payments-core": "static-1.26430",
  "ui-addon-iframeable": "static-1.9509",
  "usage-tracker": "static-1.7747",
  "usage-tracker-container": "static-1.7737",
  "sassPrefix": "static-1.322",
  "inbound-db-properties-service-client": "static-1.4124",
  "foundations-theming-base": "static-1.3900",
  "bend-plugin-foundations-theming": "static-1.3398",
  "stylex": "static-1.46",
  "opentelemetry-fe-types": "static-1.220",
  "hub-http-janus": "static-1.901",
  "hubspotter-http": "static-1.4947",
  "mobile-manifest-mixins": "static-1.599",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.595",
  "quartz-auth": "static-1.1285",
  "quartz-head": "static-1.1275",
  "quartz-test": "static-1.1285",
  "trellis-components": "static-1.3012",
  "usage-tracker-session-replay": "static-1.5433",
  "csstype": "static-1.50",
  "web-vitals": "static-1.19",
  "immer": "static-1.105",
  "bend-plugin-chirp-manifest": "static-1.513",
  "chirp-fetch": "static-1.2335",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4906",
  "FormUrlGenerator": "static-2.5148",
  "sequences-lib": "static-1.8708",
  "apollo-link-hub-http": "static-2.5022",
  "FileManagerCore": "static-1.40268",
  "FileManagerLib": "static-1.40409",
  "hubspot-apollo-client": "static-1.5312",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.689",
  "timezone-utils": "static-2.5663",
  "ui-gdpr-components": "static-1.10651",
  "react-dnd-compat": "static-1.5043",
  "stylex-utils": "static-1.166",
  "trellis-theming": "static-1.1419",
  "react-flip-move": "static-1.82",
  "avatar-components": "static-1.2917",
  "hs-resources": "static-1.630",
  "pulse": "static-1.1074",
  "utility-belt": "static-1.2969",
  "zustand": "static-1.88",
  "batch-promise": "static-1.1979",
  "customer-data-associations": "static-1.7765",
  "customer-data-property-utils": "static-1.8478",
  "customer-data-tracking": "static-1.7305",
  "framework-data-schema-resolvers": "static-1.7325",
  "framework-data-table": "static-2.12774",
  "object-builder-ui-client": "static-1.49963",
  "payments-enrollment-embed-lib": "static-1.24127",
  "stripe-embedded-components": "static-1.8180",
  "ui-addon-opt": "static-4.8819",
  "ai-components-ui-library": "static-1.9950",
  "customer-data-rte": "static-1.33833",
  "cv-backend-services": "static-1.1607",
  "file-manager-components": "static-1.24769",
  "growth-onboarding-confetti": "static-1.3495",
  "growth-onboarding-empty-states": "static-1.6469",
  "hubspot-prosemirror": "static-1.19212",
  "InboxConnectUtils": "static-4.15776",
  "payment-link-components": "static-1.24372",
  "payments-post-enroll-local-storage-lib": "static-1.5537",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39112",
  "react-colorpicker": "static-2.10646",
  "ui-addon-upgrades": "static-9.18524",
  "ui-addon-video-player": "static-1.9058",
  "user-context": "static-1.5484",
  "restore-request-side-panel-lib": "static-1.1950",
  "atom": "static-1.5511",
  "reference-resolvers": "static-1.8612",
  "calling-global-api": "static-1.66073",
  "calling-internal-common": "static-1.31758",
  "calling-lifecycle-internal": "static-1.67455",
  "calling-lifecycle-messages": "static-1.59748",
  "commerce-products-lib": "static-1.10800",
  "conditional-properties-service-client": "static-1.4094",
  "crm-index-visualization-core": "static-1.4699",
  "crm-links": "static-1.6737",
  "crm-pipelines-api-client-types": "static-1.4425",
  "customer-data-properties-shared-msw-handlers": "static-1.10161",
  "external-options-client-types": "static-1.4423",
  "formula-editor": "static-1.14955",
  "google-libphonenumber": "static-1.49",
  "inbound-db-meta-service-client": "static-1.3752",
  "inbounddb-objects-service-types": "static-1.4504",
  "meetings-icalendar-utils-lib": "static-1.1070",
  "multi-currency-client-types": "static-1.3990",
  "pipeline-validation-client-types": "static-1.4262",
  "property-value-citations": "static-1.3553",
  "reference-resolvers-lite": "static-1.8539",
  "smart-data-capture-core": "static-1.397",
  "smart-property-lib": "static-1.8556",
  "tiered-pricing": "static-1.2167",
  "topics-actions-lib": "static-1.608",
  "trellis-ext-i18n": "static-1.1323",
  "trial-components-library": "static-1.14313",
  "ui-addon-form-validation": "static-1.11341",
  "laboratory-lib": "static-3.7583",
  "onboarding-scopes": "static-1.6888",
  "seat-types-lib": "static-1.974",
  "magpie-lib": "static-1.5870",
  "navigation-messaging": "static-1.8415",
  "ts-schema": "static-1.4374",
  "opentelemetry-web": "static-1.22",
  "beacon-keepalive-queue": "static-1.133",
  "hub-http-shared-msw-handlers": "static-1.10834",
  "hubspotter-http-shared-msw-handlers": "static-1.10832",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "amplitude-session-replay-browser": "static-1.60",
  "sequences-client-types-lib": "static-1.8565",
  "breeze-artifacts-sdk": "static-1.752",
  "copilot-toolkit": "static-1.12074",
  "audio-components": "static-1.6512",
  "ContentUtils": "static-1.69386",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29999",
  "FileManagerImages": "static-1.37920",
  "html-to-image": "static-1.65",
  "immerable": "static-1.4573",
  "ui-universal-auth": "static-1.9649",
  "urlinator": "static-1.4948",
  "video-components": "static-1.14363",
  "video-data-lib": "static-1.36019",
  "video-embed": "static-1.36853",
  "hubspot-apollo-cache": "static-1.771",
  "event-emitter": "static-1.1394",
  "framework-builder-read-service-client": "static-1.4305",
  "fdsr-migration-layer": "static-1.444",
  "bend-plugin-pulse": "static-1.577",
  "fast-json-patch": "static-1.74",
  "framework-data-schema-quick-fetch": "static-1.7230",
  "persist-promise": "static-1.4136",
  "customer-data-reference-ui-components": "static-1.13600",
  "tasks-actions-lib": "static-1.367",
  "reporting-data": "static-1.69238",
  "purchase-motions-components": "static-1.6582",
  "growth-onboarding-feedback-components": "static-1.7016",
  "growth-onboarding-reliability": "static-1.5515",
  "marketplace-ui-apps-core": "static-1.19514",
  "onboarding-tours": "static-1.17335",
  "stripe-connect-js": "static-1.82",
  "chatspot-core": "static-1.23599",
  "content-assistance-lib": "static-1.8361",
  "draft-content-plugins": "static-1.29091",
  "draft-convert": "static-2.83",
  "draft-extend": "static-3.87",
  "draft-js": "static-5.89",
  "draft-plugins": "static-2.22295",
  "rich-text-lib": "static-1.20493",
  "breeze-engine-lib": "static-1.2042",
  "poll-commands": "static-1.3908",
  "video-components-external": "static-1.12361",
  "trellis-story-utils": "static-1.4935",
  "ui-addon-react-router-dom": "static-1.9963",
  "content-media-capture": "static-1.5712",
  "knowledge-content-types": "static-1.8719",
  "ui-addon-emoji-picker": "static-1.10299",
  "ui-business-units-lib": "static-1.9529",
  "ui-shepherd-react": "static-3.10709",
  "hub-http-contrib": "static-1.3462",
  "ui-addon-sales-email": "static-1.5635",
  "commerce-tours-lib": "static-1.6803",
  "getting-started-shared-tasks": "static-1.19492",
  "sales-checkout-service-client": "static-1.3959",
  "merchandise-lib": "static-1.283",
  "getting-started-shared-tasks-store": "static-1.18610",
  "onboarding-tours-utils": "static-1.1402",
  "calling-error-reporting": "static-1.31765",
  "shared-worker-versioning": "static-1.11474",
  "calling-usage-tracker": "static-1.6967",
  "voice-sms-access-library": "static-1.2352",
  "conversations-skeleton-state": "static-1.7603",
  "commerce-permissions": "static-1.1215",
  "products-iframe-lib": "static-1.8830",
  "products-ui-components-shared-msw-handlers": "static-1.11216",
  "crm-index-associations-lib": "static-1.6881",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10917",
  "sales-views-client-types": "static-1.4691",
  "location-customization-utils-lib": "static-1.10348",
  "bark-lib": "static-1.16964",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6321",
  "react-codemirror": "static-1.11072",
  "data-agent-kit": "static-1.839",
  "data-agent-test-utils": "static-1.383",
  "data-agent-utils": "static-1.852",
  "data-token-picker": "static-1.17065",
  "markdown-it": "static-1.6",
  "fsm": "static-1.4189",
  "policy-lib": "static-1.7240",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10980",
  "embedded-academy-lib": "static-1.15901",
  "hubs-service-types": "static-1.1697",
  "navigation-components": "static-1.19088",
  "nudge-client-utils": "static-1.3347",
  "purchase-motions-api": "static-1.6585",
  "signup-constants": "static-1.19863",
  "idb-keyval": "static-1.55",
  "magpie-types": "static-1.5330",
  "reactive-lib": "static-1.1156",
  "simple-logging-lib": "static-1.3484",
  "nav-meta": "static-1.30725",
  "cms-field-types": "static-1.5245",
  "content-icons-ui": "static-1.2418",
  "integrations-lib": "static-1.17331",
  "underscore": "static-1.8",
  "unified-auth-core-lib": "static-1.1445",
  "social-insights-client-types": "static-1.22869",
  "outpost": "static-1.4566",
  "reporting-client-types": "static-1.2798",
  "signup-ui-url-generator": "static-2.8492",
  "developer-experience-shared-components": "static-1.10971",
  "immutable-less": "static-1.5085",
  "marketplace-ui-client-types": "static-1.18389",
  "marketplace-ui-common": "static-1.20982",
  "ui-addon-integrations-directory-panel": "static-2.8389",
  "ui-extensibility-client-types": "static-1.4349",
  "growth-data-modal": "static-1.6074",
  "growth-onboarding-next-action-utils": "static-1.2916",
  "onboarding-tours-client": "static-1.5550",
  "ui-shepherd-tracker": "static-1.8090",
  "ui-coaching-tips": "static-1.29533",
  "breeze-engine-chat-components": "static-1.1020",
  "breeze-engine-core": "static-1.1320",
  "ably": "static-2.2",
  "highlight.js": "static-1.90",
  "content-media-composition-data-lib": "static-1.13516",
  "content-media-compositions": "static-2.17523",
  "media-bridge-lib": "static-1.19583",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4859",
  "calling-orchestration-schema": "static-1.37129",
  "crm-record-cards-service-types": "static-1.3845",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16597",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.115",
  "enrichment-settings-lib": "static-1.167",
  "storybook-react": "static-1.44",
  "academy-common-lib": "static-1.15361",
  "nest": "static-1.669",
  "nudge-custom-function-registry": "static-1.3104",
  "nudge-renderer-utils": "static-1.3423",
  "whisper-core-api": "static-1.7570",
  "flux-actions": "static-1.380",
  "integrations-error-boundary-lib": "static-1.14746",
  "integrations-tracking-lib": "static-1.6046",
  "redux-observable": "static-1.79",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1163",
  "apps-service-types": "static-1.4080",
  "oauth-service-types": "static-1.4597",
  "ai-settings-ui-library": "static-1.8517",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1470",
  "onboarding-data-sync-lib": "static-1.2777",
  "growth-onboarding-next-action-components": "static-1.2944",
  "user-context-client": "static-1.4943",
  "js-cookie": "static-1.18",
  "academy-service-client": "static-1.4127",
  "croppie": "static-2.10",
  "final-form": "static-1.82",
  "SafeStorage": "static-1.4826",
  "trellis-ecosystem": "static-1.7791",
  "wootric-nps": "static-1.7275",
  "universal-page-editor-lib": "static-1.3442",
  "adobe-sign-auth-lib": "static-1.695",
  "ads-unified-auth-lib": "static-1.1824",
  "custom-vendor-connection-lib": "static-1.213",
  "google-sheets-integration-lib": "static-1.1263",
  "microsoft-drive-auth-lib": "static-1.422",
  "surveymonkey-integration-lib": "static-1.790",
  "slack-ui-library": "static-1.10830",
  "settings-ui-lib": "static-1.12964",
  "simple-data-table": "static-1.3758",
  "meetings-connect-utils-lib": "static-1.8049"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28626",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.1978",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.507",
  "crm_data": "/crm_data/static-4.93122",
  "data-fetching-client": "/data-fetching-client/static-1.10078",
  "emoji-mart": "/emoji-mart/static-3.6",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8682",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1707",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6023",
  "hs-test-utils": "/hs-test-utils/static-1.8470",
  "hub-http": "/hub-http/static-1.6642",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11925",
  "I18n": "/I18n/static-7.1698",
  "jasmine-runner": "/jasmine-runner/static-1.6884",
  "quartz": "/quartz/static-1.7610",
  "raven": "/raven/static-3.5925",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-stripe-js": "/react-stripe-js/static-1.120",
  "react-utils": "/react-utils/static-2.5636",
  "reselect": "/reselect/static-3.16",
  "stripe-js": "/stripe-js/static-1.119",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6062",
  "UIComponents": "/UIComponents/static-3.8871",
  "usage-tracker-public": "/usage-tracker-public/static-1.7558",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38023",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.549",
  "cssUtils": "/cssUtils/static-1.1055",
  "customer-data-objects": "/customer-data-objects/static-1.8127",
  "FireAlarmUi": "/FireAlarmUi/static-1.4819",
  "foundations-assets": "/foundations-assets/static-1.5319",
  "foundations-theming": "/foundations-theming/static-1.4915",
  "graphql": "/graphql/static-1.93",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12232",
  "icons": "/icons/static-2.699",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3319",
  "property-translator": "/property-translator/static-1.5812",
  "quartz-config": "/quartz-config/static-1.1388",
  "quartz-core": "/quartz-core/static-1.6829",
  "quartz-i18n": "/quartz-i18n/static-1.1285",
  "quartz-routing": "/quartz-routing/static-1.1040",
  "quartz-tracking": "/quartz-tracking/static-1.989",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17168",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-virtualized": "/react-virtualized/static-2.111",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.84",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "ReduxMessenger": "/ReduxMessenger/static-2.10804",
  "rpc-client-utils": "/rpc-client-utils/static-1.5103",
  "sanitize-text": "/sanitize-text/static-1.8590",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.514",
  "superstore": "/superstore/static-1.5192",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11578",
  "ui-images": "/ui-images/static-2.1269",
  "usage-tracker-core": "/usage-tracker-core/static-1.7597",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3887",
  "quartz-webpack": "/quartz-webpack/static-1.3834",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.688",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "crm_universal": "/crm_universal/static-1.22663",
  "customer-data-email": "/customer-data-email/static-1.18595",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10266",
  "dispatcher": "/dispatcher/static-1.147",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8350",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8196",
  "quick-fetch": "/quick-fetch/static-1.4204",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4951",
  "floating-ui": "/floating-ui/static-1.67",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2631",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-story-utils": "/hs-story-utils/static-1.9857",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.96",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.2993",
  "ui-fonts": "/ui-fonts/static-1.1187",
  "HeadJS": "/HeadJS/static-2.816",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3581",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.24",
  "testing-library": "/testing-library/static-1.163",
  "hs-locale-management": "/hs-locale-management/static-1.374",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.95",
  "jasmine": "/jasmine/static-4.4740",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6165",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5180",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20462",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19497",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11254",
  "crm-message-bus": "/crm-message-bus/static-1.44022",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13463",
  "customer-data-properties": "/customer-data-properties/static-1.52939",
  "growth-payments-core": "/growth-payments-core/static-1.26430",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9509",
  "usage-tracker": "/usage-tracker/static-1.7747",
  "usage-tracker-container": "/usage-tracker-container/static-1.7737",
  "sassPrefix": "/sassPrefix/static-1.322",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4124",
  "foundations-theming-base": "/foundations-theming-base/static-1.3900",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3398",
  "stylex": "/stylex/static-1.46",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.220",
  "hub-http-janus": "/hub-http-janus/static-1.901",
  "hubspotter-http": "/hubspotter-http/static-1.4947",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.599",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.595",
  "quartz-auth": "/quartz-auth/static-1.1285",
  "quartz-head": "/quartz-head/static-1.1275",
  "quartz-test": "/quartz-test/static-1.1285",
  "trellis-components": "/trellis-components/static-1.3012",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5433",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.19",
  "immer": "/immer/static-1.105",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.513",
  "chirp-fetch": "/chirp-fetch/static-1.2335",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4906",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5148",
  "sequences-lib": "/sequences-lib/static-1.8708",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5022",
  "FileManagerCore": "/FileManagerCore/static-1.40268",
  "FileManagerLib": "/FileManagerLib/static-1.40409",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5312",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.689",
  "timezone-utils": "/timezone-utils/static-2.5663",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10651",
  "react-dnd-compat": "/react-dnd-compat/static-1.5043",
  "stylex-utils": "/stylex-utils/static-1.166",
  "trellis-theming": "/trellis-theming/static-1.1419",
  "react-flip-move": "/react-flip-move/static-1.82",
  "avatar-components": "/avatar-components/static-1.2917",
  "hs-resources": "/hs-resources/static-1.630",
  "pulse": "/pulse/static-1.1074",
  "utility-belt": "/utility-belt/static-1.2969",
  "zustand": "/zustand/static-1.88",
  "batch-promise": "/batch-promise/static-1.1979",
  "customer-data-associations": "/customer-data-associations/static-1.7765",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8478",
  "customer-data-tracking": "/customer-data-tracking/static-1.7305",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7325",
  "framework-data-table": "/framework-data-table/static-2.12774",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49963",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24127",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8180",
  "ui-addon-opt": "/ui-addon-opt/static-4.8819",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9950",
  "customer-data-rte": "/customer-data-rte/static-1.33833",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "file-manager-components": "/file-manager-components/static-1.24769",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3495",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6469",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19212",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15776",
  "payment-link-components": "/payment-link-components/static-1.24372",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5537",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39112",
  "react-colorpicker": "/react-colorpicker/static-2.10646",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18524",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9058",
  "user-context": "/user-context/static-1.5484",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1950",
  "atom": "/atom/static-1.5511",
  "reference-resolvers": "/reference-resolvers/static-1.8612",
  "calling-global-api": "/calling-global-api/static-1.66073",
  "calling-internal-common": "/calling-internal-common/static-1.31758",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67455",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59748",
  "commerce-products-lib": "/commerce-products-lib/static-1.10800",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4094",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4699",
  "crm-links": "/crm-links/static-1.6737",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4425",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10161",
  "external-options-client-types": "/external-options-client-types/static-1.4423",
  "formula-editor": "/formula-editor/static-1.14955",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3752",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4504",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1070",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3990",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4262",
  "property-value-citations": "/property-value-citations/static-1.3553",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8539",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.397",
  "smart-property-lib": "/smart-property-lib/static-1.8556",
  "tiered-pricing": "/tiered-pricing/static-1.2167",
  "topics-actions-lib": "/topics-actions-lib/static-1.608",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1323",
  "trial-components-library": "/trial-components-library/static-1.14313",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11341",
  "laboratory-lib": "/laboratory-lib/static-3.7583",
  "onboarding-scopes": "/onboarding-scopes/static-1.6888",
  "seat-types-lib": "/seat-types-lib/static-1.974",
  "magpie-lib": "/magpie-lib/static-1.5870",
  "navigation-messaging": "/navigation-messaging/static-1.8415",
  "ts-schema": "/ts-schema/static-1.4374",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.133",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10834",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10832",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8565",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.752",
  "copilot-toolkit": "/copilot-toolkit/static-1.12074",
  "audio-components": "/audio-components/static-1.6512",
  "ContentUtils": "/ContentUtils/static-1.69386",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29999",
  "FileManagerImages": "/FileManagerImages/static-1.37920",
  "html-to-image": "/html-to-image/static-1.65",
  "immerable": "/immerable/static-1.4573",
  "ui-universal-auth": "/ui-universal-auth/static-1.9649",
  "urlinator": "/urlinator/static-1.4948",
  "video-components": "/video-components/static-1.14363",
  "video-data-lib": "/video-data-lib/static-1.36019",
  "video-embed": "/video-embed/static-1.36853",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.771",
  "event-emitter": "/event-emitter/static-1.1394",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4305",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.444",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.577",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7230",
  "persist-promise": "/persist-promise/static-1.4136",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13600",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.367",
  "reporting-data": "/reporting-data/static-1.69238",
  "purchase-motions-components": "/purchase-motions-components/static-1.6582",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7016",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5515",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19514",
  "onboarding-tours": "/onboarding-tours/static-1.17335",
  "stripe-connect-js": "/stripe-connect-js/static-1.82",
  "chatspot-core": "/chatspot-core/static-1.23599",
  "content-assistance-lib": "/content-assistance-lib/static-1.8361",
  "draft-content-plugins": "/draft-content-plugins/static-1.29091",
  "draft-convert": "/draft-convert/static-2.83",
  "draft-extend": "/draft-extend/static-3.87",
  "draft-js": "/draft-js/static-5.89",
  "draft-plugins": "/draft-plugins/static-2.22295",
  "rich-text-lib": "/rich-text-lib/static-1.20493",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2042",
  "poll-commands": "/poll-commands/static-1.3908",
  "video-components-external": "/video-components-external/static-1.12361",
  "trellis-story-utils": "/trellis-story-utils/static-1.4935",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9963",
  "content-media-capture": "/content-media-capture/static-1.5712",
  "knowledge-content-types": "/knowledge-content-types/static-1.8719",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10299",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9529",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10709",
  "hub-http-contrib": "/hub-http-contrib/static-1.3462",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5635",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6803",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19492",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3959",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18610",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1402",
  "calling-error-reporting": "/calling-error-reporting/static-1.31765",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11474",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6967",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2352",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7603",
  "commerce-permissions": "/commerce-permissions/static-1.1215",
  "products-iframe-lib": "/products-iframe-lib/static-1.8830",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11216",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6881",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10917",
  "sales-views-client-types": "/sales-views-client-types/static-1.4691",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10348",
  "bark-lib": "/bark-lib/static-1.16964",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6321",
  "react-codemirror": "/react-codemirror/static-1.11072",
  "data-agent-kit": "/data-agent-kit/static-1.839",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.383",
  "data-agent-utils": "/data-agent-utils/static-1.852",
  "data-token-picker": "/data-token-picker/static-1.17065",
  "markdown-it": "/markdown-it/static-1.6",
  "fsm": "/fsm/static-1.4189",
  "policy-lib": "/policy-lib/static-1.7240",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10980",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15901",
  "hubs-service-types": "/hubs-service-types/static-1.1697",
  "navigation-components": "/navigation-components/static-1.19088",
  "nudge-client-utils": "/nudge-client-utils/static-1.3347",
  "purchase-motions-api": "/purchase-motions-api/static-1.6585",
  "signup-constants": "/signup-constants/static-1.19863",
  "idb-keyval": "/idb-keyval/static-1.55",
  "magpie-types": "/magpie-types/static-1.5330",
  "reactive-lib": "/reactive-lib/static-1.1156",
  "simple-logging-lib": "/simple-logging-lib/static-1.3484",
  "nav-meta": "/nav-meta/static-1.30725",
  "cms-field-types": "/cms-field-types/static-1.5245",
  "content-icons-ui": "/content-icons-ui/static-1.2418",
  "integrations-lib": "/integrations-lib/static-1.17331",
  "underscore": "/underscore/static-1.8",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1445",
  "social-insights-client-types": "/social-insights-client-types/static-1.22869",
  "outpost": "/outpost/static-1.4566",
  "reporting-client-types": "/reporting-client-types/static-1.2798",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8492",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10971",
  "immutable-less": "/immutable-less/static-1.5085",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18389",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20982",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8389",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4349",
  "growth-data-modal": "/growth-data-modal/static-1.6074",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2916",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5550",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8090",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29533",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1020",
  "breeze-engine-core": "/breeze-engine-core/static-1.1320",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.90",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13516",
  "content-media-compositions": "/content-media-compositions/static-2.17523",
  "media-bridge-lib": "/media-bridge-lib/static-1.19583",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4859",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37129",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3845",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16597",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.115",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.167",
  "storybook-react": "/storybook-react/static-1.44",
  "academy-common-lib": "/academy-common-lib/static-1.15361",
  "nest": "/nest/static-1.669",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3104",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3423",
  "whisper-core-api": "/whisper-core-api/static-1.7570",
  "flux-actions": "/flux-actions/static-1.380",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14746",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6046",
  "redux-observable": "/redux-observable/static-1.79",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1163",
  "apps-service-types": "/apps-service-types/static-1.4080",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8517",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1470",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2777",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2944",
  "user-context-client": "/user-context-client/static-1.4943",
  "js-cookie": "/js-cookie/static-1.18",
  "academy-service-client": "/academy-service-client/static-1.4127",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.82",
  "SafeStorage": "/SafeStorage/static-1.4826",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7791",
  "wootric-nps": "/wootric-nps/static-1.7275",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3442",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.695",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1824",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.213",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1263",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.422",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.790",
  "slack-ui-library": "/slack-ui-library/static-1.10830",
  "settings-ui-lib": "/settings-ui-lib/static-1.12964",
  "simple-data-table": "/simple-data-table/static-1.3758",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8049"
}
};
